import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditRecord } from '@efdigital/ll-admin-v2/components/edit-record.gts';
import type { LibraryClientsEditModel } from '@efdigital/ll-admin-v2/routes/library/clients/client';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    model: LibraryClientsEditModel;
  };
}

const ContentRoute: TemplateOnlyComponent<Signature> = <template>
  <EditContext as |context|>
    <EditRecord
      @editLabel="Edit Client"
      @item={{@model.client}}
      @context={{context}}
    >
      <:form>
        <p>Customized Content is not yet implemented.</p>
        {{!--
        <CustomizedContentSection
          @client={{@model.client}}
          @uniqueId={{uniqueId}}
          @isReadOnly={{isReadOnly}}
        />
        --}}
      </:form>
    </EditRecord>
  </EditContext>
</template>;

export default ContentRoute;
